"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Context =
/*#__PURE__*/
function () {
  function Context(type) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "+";
    var parent = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Context);

    if (type === null || type === undefined) {
      throw new TypeError("Invalid Type");
    }

    this.type = type;
    this.id = id;
    this.parent = parent;
  }

  _createClass(Context, [{
    key: Symbol.toPrimitive,
    value: function value(hint) {
      if (hint === "string" || hint === "default") {
        return this.parent !== undefined ? "".concat(this.parent, "/").concat(this.type, "/").concat(this.id) : "".concat(this.type, "/").concat(this.id);
      }

      throw new TypeError("Invalid primitive conversion");
    }
  }, {
    key: "toString",
    value: function toString() {
      return "" + this;
    }
  }]);

  return Context;
}();

exports.default = Context;